// Page Mounted Events
export const NAME_SELECT_SERVICES = 'Select Services';
export const NAME_ENTER_PET_INFO = 'Enter Pet Info';
export const NAME_ENTER_ADDRESS = 'Enter Address';
export const NAME_ENTER_OWNER_INFO = 'Enter Owner Info';
export const REQUEST_ENDORSEMENTS = 'Request Endorsements';

// Form Submit Events
export const NAME_SERVICES_SELECTED = 'Services Selected';
export const NAME_PET_INFO_ENTERED = 'Pet Info Entered';
export const NAME_ADDRESS_ENTERED = 'Address Entered';
export const NAME_OWNER_INFO_ENTERED = 'Owner Info Entered';
export const ENDORSEMENTS_SUBMITTED = 'Endorsements Submitted';

// User interaction events
export const COPY_ENDORSEMENT_LINK_TO_CLIPBOARD = 'Copy endorsements link';
